import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LocalStorageKeys } from '../local-storage/local-storage-keys.class';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { BuildInfo } from '@iot-platform/models/common';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiInterceptorService {
  private readonly httpClient = inject(HttpClient);
  private readonly localStorage = inject(LocalStorageService);

  setBuildInfo(): void {
    this.httpClient
      .get<BuildInfo>('assets/data/build.json')
      .pipe(tap((data) => this.localStorage.set(LocalStorageKeys.STORAGE_APP_BUILD_INFO, JSON.stringify(data))))
      .subscribe();
  }
}
